var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDownDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.999 9.6201L15.999 2.2501C15.9964 1.95199 15.9351 1.65732 15.8185 1.38291C15.702 1.1085 15.5326 0.859729 15.3198 0.650795C15.1071 0.441861 14.8553 0.276858 14.5788 0.165211C14.3023 0.0535631 14.0066 -0.00254284 13.7084 9.51672e-05L4.89588 9.43968e-05C4.14964 -0.00135141 3.42316 0.239764 2.82595 0.687091C2.22875 1.13442 1.79319 1.76371 1.58494 2.48009L0.0945155 7.82009C-0.0151137 8.22534 -0.0294277 8.65045 0.0526963 9.06215C0.13482 9.47385 0.311152 9.86096 0.567886 10.1932C0.824619 10.5254 1.15479 10.7937 1.53254 10.977C1.91028 11.1604 2.32536 11.2538 2.74527 11.2501L7.99675 11.2501L7.58664 16.0001C7.56282 16.2552 7.59284 16.5124 7.67474 16.7551C7.75664 16.9978 7.88861 17.2207 8.0621 17.4092C8.23559 17.5977 8.44674 17.7477 8.68188 17.8495C8.91703 17.9513 9.17093 18.0026 9.42716 18.0001C9.69521 17.9997 9.96001 17.9414 10.2034 17.8293C10.4469 17.7171 10.6632 17.5536 10.8376 17.3501L14.9387 12.5001C15.6241 11.6971 16.0001 10.6757 15.999 9.6201Z",
    fill: "#303037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 9.75012C17.5 10.4405 18.0596 11.0001 18.75 11.0001C19.4404 11.0001 20 10.4405 20 9.75012L20 1.25012C20 0.559766 19.4404 0.000122021 18.75 0.000121961C18.0596 0.000121901 17.5 0.559766 17.5 1.25012L17.5 9.75012Z",
    fill: "#303037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownDark);
export default __webpack_public_path__ + "static/media/thumbs-down-dark.a0f3e86a557d8c4992a1c099ef267623.svg";
export { ForwardRef as ReactComponent };